import { useState, useEffect } from 'react';
import './login.scss';
import classNames from 'classnames';
import { LoginBackgroundAnimation } from './components/LoginBackgroundAnimation/LoginBackgroundAnimation';
import { NewUserNoPassword } from './components/NewUserNoPassword/NewUserNoPassword';

export function NewUserNoPasswordPage() {
  const [animation, setAnimation] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setAnimation(true);
    }, 1000);
  }, []);

  return (
    <div className={classNames('Login', { animation: animation })}>
      <LoginBackgroundAnimation />
      <NewUserNoPassword />
    </div>
  );
}
